import {CustomerInterestTier} from "../../resources/depositProduct"

export function isBasisPoints(formula: string): boolean {
	return /^\d+$/.test(formula.trim())
}

export function formatCents(cents: number): string {
	const dollars = cents / 100
	return dollars.toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})
}

export function getTierRateDisplay(tier: CustomerInterestTier): string | null {
	const formula = tier.formula.trim()
	if (isBasisPoints(formula)) {
		const rate = parseInt(formula, 10) / 100
		return `${rate}%`
	}
	return null
}

export function getTierRangeDisplay(tier: CustomerInterestTier): string {
	const lower = tier.lowerBound !== undefined ? formatCents(tier.lowerBound) : "$0"
	if (tier.higherBound === undefined) {
		return `${lower} and above`
	}
	const upper = formatCents(tier.higherBound - 1)
	return `${lower} - ${upper}`
}
